import { useQuery } from 'react-query';
import { baseURL } from 'Types/APITypes';
import { CommercialOverrides } from 'components/CommercialOverrides/CommercialOverridesFields';
import { MaestroAPI, maestroApiCall } from '@michelin/central-provider';

const getCommercialOverrides = (stNumber: string|null) => {
  if (!stNumber) return null;
  return maestroApiCall({
    method: 'GET', endpoint: `locations/${stNumber}/commercial-overrides`, baseURL,
  });
};

interface saveParams<T> {
  stNumber: string,
  data: T
}

export async function saveCommerciaOverrides({ stNumber, data }: saveParams<CommercialOverrides>) {
  const apiType: MaestroAPI = { method: 'PUT', endpoint: `locations/${stNumber}/commercial-overrides`, baseURL };
  const response = await maestroApiCall(apiType, {
    ...data,
    overrides_original: undefined,
  }).then((res) => res.data);
  return response;
}

export function useCommercialOverrides(locationNumber: string|null) {
  return useQuery<unknown, unknown, CommercialOverrides>(
    ['commercial-overrides', locationNumber],
    () => getCommercialOverrides(locationNumber),
    {
      cacheTime: 3600,
      keepPreviousData: true,
    },
  );
}
